// /src/push.js
import { PushNotifications } from "@capacitor/push-notifications";
import { Capacitor } from "@capacitor/core";

let didInit = false;

export async function initPush({ apiFetch }) {
  console.log(
    "platform=",
    Capacitor.getPlatform(),
    "isNative=",
    Capacitor.isNativePlatform()
  );

  // roda só em device (iOS / Android)
  if (Capacitor.getPlatform() === "web") return;

  // evita reinit (React StrictMode / remounts)
  if (didInit) return;
  didInit = true;

  try {
    // 1) listeners (SEMPRE antes do register)
    PushNotifications.addListener("registration", async (token) => {
      try {
        console.log(
          "[push] registered token:",
          token?.value?.slice?.(0, 10),
          "..."
        );

        await apiFetch("/api/push/register", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            platform: Capacitor.getPlatform(), // "ios" | "android"
            token: token.value,
          }),
        });

        console.log("[push] token saved on server ✅");
      } catch (e) {
        console.warn(
          "[push] failed to save token on server:",
          e?.message || e
        );
      }
    });

    PushNotifications.addListener("registrationError", (err) => {
      console.warn("[push] registrationError:", err);
    });

    // útil para debug e futuro deep-link
    PushNotifications.addListener(
      "pushNotificationActionPerformed",
      (e) => {
        console.log("[push] action performed:", e);
      }
    );

    // (opcional) debug de recebimento em foreground
    PushNotifications.addListener("pushNotificationReceived", (n) => {
      console.log("[push] received:", n);
    });

    // 2) permissions
    const perm = await PushNotifications.requestPermissions();
    console.log("[push] permission:", perm);

    if (perm.receive !== "granted") {
      console.log("[push] permission not granted");
      return;
    }

    // 3) register
    console.log("[push] calling register()");
    await PushNotifications.register();
  } catch (e) {
    console.warn("[push] init failed:", e?.message || e);
  }
}
